import React from 'react'
import { Outlet } from 'react-router-dom'

// import Expertise from "../components/Expertise/Expertise"
// import TechStack from "../components/TechStack/TechStack"
// import WhatsAppButton from ".././components/WhatsAppButton"

// import Services from "../components/Services/Services"



function LandingPage() {
  return (
    <div>
        <Outlet/>
        {/* <TechStack/>
        <Expertise/>
        <WhatsAppButton/>
        <Services/>         */}
    </div>
  )
}

export default LandingPage